<acep-master [env]="env" [inheritsso]="'false'" (logout)="logout()" #acepMaster>

    <div class="bodyCtr" slot="bodySlot">
        <div class="container-fluid p-0 h-100">
            <section>
                <div class="content-wrapper">
                    <div class="loader"></div>



                    <h1 class="pagetitle mt-sm">{{!isGroupSearch ? 'Group Member Portal' : 'Employer Profile Search'}}
                    </h1>

                    <div [ngStyle]="{ 'height.px': sideNavHeight }" class="{{!!groupPortalDataService.groupList.FormGroupInfo ? 'side-nav float-left gpTop' : 'side-nav gpTop'}}"
                        *ngIf="!isGroupSearch">
                        <app-side-nav [hidden]="groupPortalDataService.hideNavigation"
                            [groupList]="groupPortalDataService.groupList.accountContacts"
                            [searchContactList]="groupPortalDataService.groupList?.searchContactList"
                            [slideOutType]="groupPortalDataService.groupList?.slideOutType"
                            [selectedGroup]="groupPortalDataService.groupList?.selectedGroup"
                            [ui_stateprovinces]="dataService.uidata?.StateProvinces"
                            [ui_countries]="dataService.uidata?.Countries" [npiExist]="groupPortalDataService.npiExists"
                            [slideOutShown]="groupPortalDataService.slideOutShown"
                            [emailExists]="groupPortalDataService.emailExists"
                            [ui_prefixes]="dataService.uidata?.Prefix"
                            [ui_residencies]="dataService.uidata?.Residencies"
                            [ui_specialities] = "dataService.uidata?.Speciality">
                        </app-side-nav>
                    </div>
                    <div class="body-content container-fluid m-0 px-0 pt-3" *ngIf="!isGroupSearch">
                        <app-group-header [hidden]="groupPortalDataService.hideNavigation"
                            [errorMessage]="groupPortalDataService.errorMessage"
                            [errorExists]="groupPortalDataService.errorExist"
                            [headerInfo]="groupPortalDataService.headerInfo"></app-group-header>
                    </div>

                    <div #routerComp id="routerComp" class="routerComp">
                        <router-outlet></router-outlet>
                    </div>
                    <link rel="stylesheet" type="text/css" [href]="csspath | safe">
                </div>


            </section>
        </div>


    </div>
</acep-master>